import { User } from 'src/app/core/models/user';

export interface AuthAction {
  type: string;
  payload?: any;
}

export class Login implements AuthAction {
  readonly type = 'LOGIN';

  constructor(public payload: LoginPayload) {}
}

export class BusinessLogin implements AuthAction {
  readonly type = 'BUSINESS_LOGIN';

  constructor(public payload: BusinessLoginPayload) {}
}

export class BusinessCertificateLogin implements AuthAction {
  readonly type = 'BUSINESS_CERTIFICATE_LOGIN';

  constructor(public payload: BusinessCertificateLoginPayload) {}
}

export class SetAuthenticationApp implements AuthAction {
  readonly type = 'SET_AUTHENTICATION';

  constructor(public payload: SetAuthenticationPayload) {}
}

export class Logout implements AuthAction {
  readonly type = 'LOGOUT';
  constructor(public payload?: LogoutPayload) {}
}

export class InterceptToken implements AuthAction {
  readonly type = 'INTERCEPT_TOKEN';

  constructor(public payload: { token: string }) {}
}

export class AcceptRGPDUE implements AuthAction {
  readonly type = 'ACCEPT_RGPDUE';

  constructor() {}
}

export class UpdatePasswordAction implements AuthAction {
  readonly type = 'UPDATE_PASSWORD';

  constructor(public payload?: UpdatePasswordPayload) {}
}

export class UpdatePersonalDataAction implements AuthAction {
  readonly type = 'UPDATE_PERSONAL_DATA';

  constructor(public payload?: UpdatePersonalDataPayload) {}
}

export class UpdatePhoneAction implements AuthAction {
  readonly type = 'UPDATE_PHONE';

  constructor(public payload?: UpdatePhonePayload) {}
}

export class UpdateLegalRepresentativeAction implements AuthAction {
  readonly type = 'UPDATE_LEGAL_REPRESENTATIVE';

  constructor(public payload?: UpdateLegalRepresentativePayload) {}
}

export class UpdateCompanyPhoneAction implements AuthAction {
  readonly type = 'UPDATE_COMPANY_PHONE';

  constructor(public payload?: UpdatePhonePayload) {}
}

export interface UpdateLegalRepresentativePayload {
  name: string;
  surname1: string;
  surname2: string;
  email: string;
  birthdate: string;
}

export interface UpdatePasswordPayload {
  password: string;
}

export interface UpdatePersonalDataPayload {
  email?: string;
  birthdate?: string;
}

export interface UpdatePhonePayload {
  phone: string;
}

export interface LogoutPayload {
  softLogout: boolean;
}

export interface SetAuthenticationPayload {
  type: AuthenticationType;
}

export type LoginPayload =
  | {
      type: AuthType.PASSWORD;
      documentNumber: string;
      password: string;
    }
  | {
      type: AuthType.FACE;
      documentNumber?: never;
      password?: never;
    }
  | {
      type: AuthType.FINGERPRINT;
      documentNumber?: never;
      password?: never;
    }
  | {
      type: AuthType.SIM;
      documentNumber: string;
      password: string;
      nuumaSim: string;
    }
  | {
      type: AuthType.TOKEN;
      token: string;
    }
    | {
      type: AuthType.ACI;
      password: string;
      username: string;
    };

export type BusinessLoginPayload = {
  type: AuthType.PASSWORD;
  cif: string;
  nif: string;
  password: string;
};

export type BusinessCertificateLoginPayload = {
  token: string;
  cif: string;
  nif: string;
};

export enum AuthType {
  PASSWORD = 0,
  FINGERPRINT = 1,
  FACE = 2,
  SIM = 3,
  TOKEN = 4,
  ACI = 5
}

export type AuthenticationType =
  | 'FINGERPRINT_APP'
  | 'PASSWORD_APP'
  | 'FACEID_APP';

export interface Auth {
  isLogged: boolean;
  sessionCounter?: number;
  preferences?: AppAuthPreferences;
  // Business Data
  user?: User;
}

export interface UserLoginError {
  remoteHttpStatus?: number;
  remoteExtradata: {
    status?: number;
    attempts?: number;
  };
}

export interface AppAuthPreferences {
  type: AuthenticationType;
  documentNumber: string;
  name: string;
  // Sim data
  nuumaSim?: string;
}

